var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarnFreeCredits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#16A249",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20H16C15.4477 20 15 20.4477 15 21V23C15 23.5523 15.4477 24 16 24H32C32.5523 24 33 23.5523 33 23V21C33 20.4477 32.5523 20 32 20Z",
    stroke: "#16A249",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20V33",
    stroke: "#16A249",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24V31C31 31.5304 30.7893 32.0391 30.4142 32.4142C30.0391 32.7893 29.5304 33 29 33H19C18.4696 33 17.9609 32.7893 17.5858 32.4142C17.2107 32.0391 17 31.5304 17 31V24",
    stroke: "#16A249",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.9999C18.837 19.9999 18.2011 19.7366 17.7322 19.2677C17.2634 18.7989 17 18.163 17 17.4999C17 16.8369 17.2634 16.201 17.7322 15.7322C18.2011 15.2633 18.837 14.9999 19.5 14.9999C20.4647 14.9831 21.41 15.4512 22.2127 16.3431C23.0154 17.235 23.6383 18.5094 24 19.9999C24.3617 18.5094 24.9846 17.235 25.7873 16.3431C26.59 15.4512 27.5353 14.9831 28.5 14.9999C29.163 14.9999 29.7989 15.2633 30.2678 15.7322C30.7366 16.201 31 16.8369 31 17.4999C31 18.163 30.7366 18.7989 30.2678 19.2677C29.7989 19.7366 29.163 19.9999 28.5 19.9999",
    stroke: "#16A249",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnFreeCredits);
export default __webpack_public_path__ + "static/media/Earn Free Credits.d484051a1deb5713dcb0735280f72072.svg";
export { ForwardRef as ReactComponent };